import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ibadown from '../../../asset/images/ibaimages/iba-down.svg';
import Loader from "../../../Components/Common/Loader";

const IBAChart = ({ graphDetails = [], title, handleDownload, loader }) => {
  const [month, setMonth] = useState([]);
  const [accountsOpened, setAccountsOpened] = useState([]);

  const colors = ["#007bff", "#0dbf8d", "#ff86b1"];

  useEffect(() => {
    if (!Array.isArray(graphDetails) || graphDetails.length === 0) return;
    const sortedData = [...graphDetails].sort(
      (a, b) => a.year - b.year || a.monthNo - b.monthNo
    );

    setMonth(
  sortedData.map(item => `${item.label}-${String(item.year).slice(-2)}`)
);
    // setMonth(sortedData.map(item => item.label));
    setAccountsOpened(sortedData.map(item => item.value));
  }, [graphDetails]);

  const payInPayOut = {
    chart: {
      type: "column"
    },
    
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: month,
      lineWidth: 1,
      lineColor: "#000000",
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      gridLineWidth: 0,
      lineWidth: 1,
      lineColor: "#000000",
      title: {
        text: null,
        align: "high",
      },
      labels: {
        enabled: false,
        overflow: "justify",
      },
    },
    legend: {
      enabled: false,
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      symbolRadius: 6,
      itemMarginBottom: 8,
      x: 50,
      itemStyle: {
        fontFamily: "Rubik",
        fontSize: "12px",
        fontWeight: 500,
      },
    },
    plotOptions: {
      column: {
        pointWidth: 30,
        groupPadding: 0,
        pointPadding: 0,
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          formatter: function () {
        return this.y.toString(); // no spaces, no commas
      }
        },

        point: {
        events: {
          mouseOver: function () {
            if (this.dataLabel) {
              this.dataLabel.hide();
            }
          },
          mouseOut: function () {
            if (this.dataLabel) {
              this.dataLabel.show();
            }
          }
        }
        }

      },
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.y}</b>`;
    // return `<b>${this.y.toLocaleString('en-IN')}</b>`;
  }
      // pointFormat: `{series.name}: <b>{point.y}</b>`,
    },
    series: [
      {
        color: "#1C74D0",
        type: "column",
        // name: "Lorem ipsum dolor",
        data: accountsOpened,
      }
    ],
  };

  return (
    <div style={{ marginTop: "40px", display: "flex", gap: "20px", flexDirection: "column" }}>
      <div className="chart-header" style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <div style={{ fontSize: "16px", fontFamily: "Rubik", fontWeight: "500", color: "#000000" }}>{title}</div>
        <span style={{ fontSize: "12px", fontFamily: "Rubik", fontWeight: "500", color: "#1C74D0", cursor: 'pointer' }}
        onClick={handleDownload}>
          <img src={ibadown} alt="" width={"12px"} height={"12px"} /> Download Report
        </span>
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "start" }}>
        
      
        <div style={{ width: "70%", height: "400px" }} className="overview-div admin-chart">
          {loader ?
         <div className="loader-alignment">
                <Loader />
              </div>
              :
          <HighchartsReact highcharts={Highcharts} options={payInPayOut} />
          }
        </div>
        
      </div>
    </div>
  );
};

export default IBAChart;
